// extracted by mini-css-extract-plugin
export default {"root":"MiNX6","text-block":"_1u5I8","textBlock":"_1u5I8","prefix":"_1ROuR"};